export const getGeometriesErrorTranslations = t => {
  const translations = t => ({
    wktNotValid: t("errors.importGeometries.wktNotValid"),
    duplicatedValues: t("errors.importGeometries.duplicatedValues"),
    fileNotValid: t("errors.importGeometries.fileNotValid")
  });

  return translations(t !== undefined ? t : str => str);
};
